import { Observable, firstValueFrom, of } from 'rxjs';
import { Injectable, isDevMode } from '@angular/core';
import { User } from './user.model';
import { WancomHttpService } from '../../services/wancom-http/wancom-http.service';
import { environment } from '../../../environments/environment';
import { Crisp } from 'crisp-sdk-web';
import { CRS } from 'leaflet';

@Injectable({
    providedIn: 'root',
})
export class UserAuthService {
    static user: User;
    private static lanchRefreshUserInfos: boolean = false;

    constructor(private readonly http: WancomHttpService) {
        this.refreshUserInfos();
    }

    saveLocalStorage(key, value): void {
        const val = JSON.stringify(value);
        localStorage.setItem(key, val);
    }
    loadLocalStorage<T>(key): T | undefined {
        const val = localStorage.getItem(key);
        if (val) return JSON.parse(val);
        else return undefined;
    }

    async refreshUserInfos(forceRefresh: boolean = false): Promise<User> {
        if (
            (!UserAuthService.user && !UserAuthService.lanchRefreshUserInfos) ||
            forceRefresh
        ) {
            UserAuthService.lanchRefreshUserInfos = true;
            let value = this.loadLocalStorage<User>('account/who-am-i');

            if (!value || forceRefresh) {
                value = await firstValueFrom(
                    this.http.get<User>(
                        'account/who-am-i',
                        environment.apiBaseStore
                    )
                );
                this.saveLocalStorage('account/who-am-i', value);
            }
            UserAuthService.user = value;
            UserAuthService.lanchRefreshUserInfos = false;
        }
        return UserAuthService.user;
    }

    getHomeUrl(): Observable<HomeUrl> {
        let homeUrl = new HomeUrl();
        if (UserAuthService.user?.homeUrl) {
            homeUrl.url = UserAuthService.user?.homeUrl;
        }
        return of(homeUrl);
    }

    hasRight(right: string): boolean {
        if (!UserAuthService.user?.wvRights) return false;
        return UserAuthService.user.wvRights.indexOf(right) !== -1;
    }

    hasFeature(features: string): boolean {
        if (!UserAuthService.user?.features) return false;
        return UserAuthService.user.features.indexOf(features) !== -1;
    }

    isAllowed(feature: string, right: string): boolean {
        return this.hasFeature(feature) || this.hasRight(right);
    }

    /**
     *
     * @returns true if current user has an Id = is logged
     */
    isLogged(): boolean {
        return UserAuthService.user?.id != null;
    }

    async signOut(): Promise<void> {
        UserAuthService.user = undefined;
        UserAuthService.lanchRefreshUserInfos = false;
        if (caches) {
            await caches.keys().then(async function (names) {
                for (let name of names) await caches.delete(name);
            });
        }
        if (window.navigator && navigator.serviceWorker) {
            await navigator.serviceWorker
                .getRegistrations()
                .then(async function (registrations) {
                    for (let registration of registrations) {
                        await registration.unregister();
                    }
                });
        }

        if (Crisp.isCrispInjected()) {
            this.resetCrisp();
        }
    }

    public initCrisp(userInfo: User) {

        if (userInfo) {

            if (!Crisp.isCrispInjected()) {                
                Crisp.configure('7d4a0471-984f-4f44-a5cd-e0ef1ef779b4', {
                    safeMode: true
                });
                Crisp.chat.hide();
            } else {
                Crisp.chat.show();
            }
            Crisp.setTokenId(userInfo.id);

            let nickName: string = `${userInfo.firstName} ${userInfo.lastName}`;
            if (isDevMode()) {
            
                nickName += " - TEST DEV"
            }


            Crisp.user.setNickname(
                nickName
            );

            Crisp?.session?.setData({
                user_id: userInfo.id,
                userInfoId: userInfo.id,
                organizationId: userInfo.organizationId
            });

            if (isDevMode()) {
                Crisp.session?.setSegments([
                    'DEBUG'
                ], true);
            }

            /**
             * Volé ici https://dirask.com/posts/TypeScript-validate-email-with-regex-Dn40Ej
             */
            const mailRegex: RegExp =
                /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

            if (mailRegex.test(userInfo.userName)) {
                Crisp.user.setEmail(userInfo.userName);
            }

        }
    }

    public resetCrisp() {
        Crisp.chat.close();
        Crisp.chat.hide();
        // Crisp.setTokenId(); // 1. Clear the token value
        // Crisp.session.reset(); // 2. Unbind the current session
    }

    /**
     *
     * @param tourId Id du tour à compléter (pas utyilisé pour le moment)
     * @returns
     */
    public updateGuidedTourInfo(tourId: string) {
        if (tourId === 'ParkTour') {
            return this.http.post(
                `account/updateGuidedTourInfo`,
                null,
                environment.apiBaseStore
            );
        }
    }
}

export class HomeUrl {
    url: string;
}
